
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/documents",
      function () {
        return require("private-next-pages/documents/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/documents"])
      });
    }
  